import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import {
  getNumbersAfterEditCamera,
  getNumbersAfterSites,
} from "../EditCamera/EditCamera";

export const NewIgnoreZonesBreadCrumbs = ({
  linksArray,
  cameraName,
  handleSitesBreadcrumbClick,
  handleSingularSiteBreadcrumbClick,
  styling,
}: {
  linksArray: { name: string }[];
  cameraName: string;
  handleSitesBreadcrumbClick: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
  handleSingularSiteBreadcrumbClick: () => void;
  styling: string;
}) => {
  const navigate = useNavigate();

  const handleCameraBreadcrumbClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    navigate(
      `/sites/${getNumbersAfterSites(
        location.href
      )}/editcamera/${getNumbersAfterEditCamera(location.href)}`
    );
  };

  return (
    <Stack spacing={2}>
      <div className={styling}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="medium" />}
          aria-label="breadcrumb"
        >
          {linksArray.map((object, index) => {
            if (index === 0) {
              return (
                <Link
                  underline="hover"
                  key={object.name}
                  color="inherit"
                  href="/sites"
                  sx={{
                    fontSize: "18px",
                    fontFamily: "Mulish",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  variant="h5"
                  onClick={handleSitesBreadcrumbClick}
                >
                  {object.name}
                </Link>
              );
            }
            if (index === linksArray.length - 1) {
              return (
                <Link
                  underline="hover"
                  key={object.name}
                  color="inherit"
                  sx={{
                    fontSize: "18px",
                    fontFamily: "Mulish",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  variant="h5"
                  onClick={handleSingularSiteBreadcrumbClick}
                >
                  {object.name}
                </Link>
              );
            }
            return null;
          })}
          <Link
            underline="hover"
            color="inherit"
            sx={{
              fontSize: "18px",
              fontFamily: "Mulish",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            variant="h5"
            onClick={handleCameraBreadcrumbClick}
          >
            {cameraName}
          </Link>
          <Typography
            color="text.primary"
            fontSize="18px"
            fontFamily="Mulish"
            fontWeight="bold"
          >
            Ignore Zones
          </Typography>
        </Breadcrumbs>
      </div>
    </Stack>
  );
};

export const createNewIgnoreZonesLinksArray = (pushedArray: string[]) => {
  const linksArray = [{ name: "Sites" }];
  pushedArray.forEach((name: string) => {
    linksArray.push({ name });
  });
  return linksArray;
};
